import type { BadgeVariant } from '@/components/Badge';
import type { SalaryAndWagesSelector } from '@/routes/_staff/salary-and-wages-mock/-utils/i18n';
import type { MemberRow } from './-utils/memberRows';

/** 一覧のページサイズ既定値。URL の不正値からのフォールバック先も兼ねる。 */
export const DEFAULT_PAGE_SIZE = 50;

/**
 * members.categoryTabs.*（従業員 / 役員のフィルタタブラベル）。
 * 戻り値型を `object` に広げないため `satisfies` を使う（`-utils/i18n.ts` と同じ流儀）。
 */
export const categoryTabSelectors = {
  board: $ => $.members.categoryTabs.board,
  employee: $ => $.members.categoryTabs.employee
} satisfies Record<MemberRow['category'], SalaryAndWagesSelector>;

/** members.status.*（在籍状況ラベル） */
export const memberStatusSelectors = {
  active: $ => $.members.status.active,
  terminated: $ => $.members.status.terminated
} satisfies Record<MemberRow['status'], SalaryAndWagesSelector>;

/** 在籍状況バッジの見た目。在籍=success 系、退職=neutral 系 */
export const statusBadgeVariant = {
  active: 'mutedSuccess',
  terminated: 'neutralMuted'
} satisfies Record<MemberRow['status'], BadgeVariant>;